import { useState } from 'react';

/**
 * Custom hook for managing the state of the upload page.
 *
 * @returns {Array} - A tuple containing the state object and the state update function.
 * @returns {State} - The state object.
 * @returns {React.Dispatch<React.SetStateAction<State>>} - The state update function.
 */
export const useUploadPageState = (): [
    State,
    React.Dispatch<React.SetStateAction<State>>
] => {
    const [state, setState] = useState<State>({
        valueClient: '',
        valueBin: '',
        openDialog: false,
        uploadZone: false,
        validateFile: false,
        openDialogFile: false,
        uploadProgress: false,
        openDialogComplete: false,
        fileData: [],
        fileBlob: null,
        dataOfClient: [],
        fileFailure: [],
        dropdownOpen: false,
        fileStatus: '-',
        failedUpload: false,
        failedBlob: false,
        isProcessingData: false,
        isChoosingFile: false,
        fileNetworkFailure: [],
    });

    return [state, setState];
};
